/**
 * Reducer function to calculate sum of values.
 * @param acc Sum accumulator
 * @param val Current numeric value
 */
export const sum = (acc: number, val: number) => acc + val;

/**
 * Reducer function to calculate product of a set of values.
 * @param acc Product accumulator
 * @param val Current numeric value
 */
export const product = (acc: number, val: number) => acc * val;
